module.exports = "/_next/static/images/fcac4a25012eabb79be977625d5c57c0-man-holding-two-phones@0.75x.jpg";